<div class="grid grid-nogutter w-screen h-screen login-page-container">
  <div class="col-12 lg:col-6 h-screen overflow-y-auto" id="login-pane">
    <div class="w-full flex align-items-center px-4 py-6 md:px-6" role="banner">
      <img src="assets/images/my-ccs-med-logo.svg" height="46" data-cy="ccs-logo" alt="My CCS Med Logo" />
    </div>
    <div role="main">
      <app-login-page>
        <div class="agents-log-in-container overflow-hidden" data-cy="agent-login-container">
          <div class="message-container" *ngFor="let err of errors">
            <app-message severity="error" [noMargin]="false" data-cy="session-expired-message">
              {{ err.uiMessage }}
            </app-message>
          </div>
          <div class="message-container">
            <h1 class="okta-form-title">Agent Log In</h1>
            <div class="flex align-items-center" *ngIf="signInAgentIsLoading || searchUsersIsLoading">
              <app-glyph-spinner class="mr-3"></app-glyph-spinner>
              <h3 *ngIf="signInAgentIsLoading">Authenticating Agent...</h3>
              <h3 *ngIf="searchUsersIsLoading">
                Searching for patient {{ (signInAgentWithOtpState$ | async)?.data?.patientId }}...
              </h3>
            </div>
          </div>
        </div>
      </app-login-page>
    </div>
  </div>

  <div class="hidden lg:block lg:col-6" role="complementary">
    <div class="h-screen">
      <img src="./assets/images/login-image.jpg" class="w-full h-full block login-image" alt="" />
    </div>
  </div>
</div>
